<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-"><span class="CharOverride-2">Voicing the Eagle</span></p>
<p class="subtitle"><span class="CharOverride-2">A True Story of Courage and Valor</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-2">Amanda Matti</span></p>
<p class="ORIM-Author-Name--Front-Matter-"><span class="CharOverride-2"><img src="images/logo.jpg"/></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// VoicingtheEagle22.vue?db6af0ac